/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "/quotes";

export const QUOTES_ROUTES = {
  BASE,
  ROOT: `${BASE}/*`,
  NAME: "Quotes",
} as const;

export const QUOTE_DETAIL_ROUTE = `${BASE}/:quoteId`;
export const QUOTE_ORDER_SUBMITTED_ROUTE = "/quote-order-submitted/:confirmationId";
export const REQUEST_QUOTE_SUCCESS_ROUTE = "/request-quote-success";
